import { render, staticRenderFns } from "./OrderPayments.vue?vue&type=template&id=386b3c4e&scoped=true"
import script from "./OrderPayments.vue?vue&type=script&lang=js"
export * from "./OrderPayments.vue?vue&type=script&lang=js"
import style0 from "./OrderPayments.vue?vue&type=style&index=0&id=386b3c4e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "386b3c4e",
  null
  
)

export default component.exports